import type { SttModelOption } from "~/utils/stt-models";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../ui/select";

interface ModelSelectProps {
	options: SttModelOption[];
	value: string;
	onValueChange: (value: string) => void;
	disabled?: boolean;
	"aria-label"?: string;
}

/**
 * The transcription-model dropdown, shared by the in-room settings panel and
 * the room-creation flow so both always offer the same models.
 */
export const ModelSelect = ({
	options,
	value,
	onValueChange,
	disabled = false,
	"aria-label": ariaLabel,
}: ModelSelectProps) => (
	<Select disabled={disabled} onValueChange={onValueChange} value={value}>
		<SelectTrigger aria-label={ariaLabel} className="w-full">
			<SelectValue />
		</SelectTrigger>
		<SelectContent className="bg-background">
			{options.map((option) => (
				<SelectItem key={option.value} value={option.value}>
					<span>{option.label}: </span>
					<span className="text-xs">{option.shortDescription}</span>
				</SelectItem>
			))}
		</SelectContent>
	</Select>
);
